import { useCallback } from 'react'
import { LOCALSTORAGE_KEY_NEWSLETTER_DIALOG } from '../../constants'
import { useFormAction } from '../form-action'
import { getNextMonthDate } from '../../utils/date'
import { useLocalStorage } from '../useLocalStorage'
import { useTrackingsActions } from '../trackings'

export const useNewsletter = () => {
	const { action: formAction, loading, error } = useFormAction()
	const [, setStorageValue] = useLocalStorage(LOCALSTORAGE_KEY_NEWSLETTER_DIALOG, false)
	const { subscribeNewsletter: trackingSubscribeNewsletter } = useTrackingsActions()

	const action = useCallback(
		async ({ formData, source }) => {
			const formDataEdited = formData

			if (formDataEdited.collections) {
				let collections = ''

				Object.keys(formDataEdited.collections).forEach((key, index) => {
					collections +=
						key +
						(formDataEdited.collections[key] ? '1' : 0) +
						(index === Object.keys(formDataEdited.collections).length - 1 ? '' : ',')
				})

				formDataEdited.collections = collections
			}

			const result = await formAction({
				formID: 'newsletter',
				params: { ...formDataEdited, source },
			})

			if (result) {
				trackingSubscribeNewsletter({ source })
			}
			setStorageValue(true, getNextMonthDate())

			return result
		},
		[formAction, setStorageValue, trackingSubscribeNewsletter]
	)

	return {
		action,
		loading,
		error,
	}
}
